import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../Stylesheets/Monthtimeline.css";

import AOS from "aos";

const timelineData = [
  {
    time: "Final Project",
    icon: "https://d242nlqul83u9g.cloudfront.net/adminpanel/carrermate/img33209_IMG.png",
    title: "Final Project Presentation",
    description: [
      "Each trainee presents the project to trainers and evaluators.",
      "Assessed on coding, functionality, teamwork, and presentation skills.",
    ],
    thumbs: [],
    badges: [{ text: "Project Demo", color: "primary" }],
  },
  {
    time: "Evaluation",
    icon: "https://d242nlqul83u9g.cloudfront.net/adminpanel/carrermate/img79098_IMG.png",
    title: "Evaluation Parameters",
    description: [
      "Technical Knowledge (40%)",
      "Discipline Score (30%)",
      "Interview & Communication (30%)",
    ],
    thumbs: [],
    badges: [{ text: "Assessment", color: "warning text-dark" }],
  },
  {
    time: "Transition",
    icon: "https://d242nlqul83u9g.cloudfront.net/adminpanel/carrermate/img56685_IMG.png",
    title: "Results and Transition to Employment Phase",
    description: [
      "Only those who pass evaluation are eligible for Phase 2.",
      "Others may be offered re-training opportunities based on performance.",
    ],
    thumbs: [],
    badges: [{ text: "Next Phase", color: "success" }],
  },
];

const Month6 = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
    window.scrollTo({ behavior: "smooth", top: 0 });
  }, []);

  return (
    <section
      id="monthtimeline"
      className="min-vh-100 position-relative overflow-hidden"
    >
      {/* Background Video */}
      {/* <div className="home-bg">
        <video loop autoPlay muted playsInline>
          <source src={bg_video} />
        </video>
        <div className="video-overlay"></div>
      </div> */}

      <div className="container text-light position-relative">
        <h1 className="text-center py-3 mt-5 fw-bold gradient-text monthtimeline" style={{fontFamily:"'Merriweather', serif"}}>
       Final Evaluation
        </h1>
        <div className="timeline">
          {timelineData.map((item, index) => (
            <div className="timeline-row" data-aos="fade-up" key={index}>
              <div
                className="timeline-time text-light fw-bold"
                data-aos="zoom-in-up"
              >
                {item.time}
              </div>
              <div className="timeline-content">
                <img
                  src={item.icon}
                  alt={item.title}
                  className="timeline-icon"
                />
                <h4 style={{color:" rgb(7, 223, 252)"}}>{item.title}</h4>

                {/* Description as <ul> */}
                <ul>
                  {item.description.map((point, i) => (
                    <li key={i}>{point}</li>
                  ))}
                </ul>

                <div>
                  {item.badges.map((badge, i) => (
                    <span
                      key={i}
                      className={`badge rounded-pill bg-${badge.color} ${
                        i > 0 ? "ms-1" : ""
                      }`}
                    >
                      {badge.text}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Month6;
